/*
 * @Author: yinbing.liu
 * @Date: 2023-09-19 15:15:43
 * @LastEditors: liuYingBing
 * @LastEditTime: 2024-03-06 14:43:04
 * @FilePath: /fushigi/src/utils/routes.ts
 * @Description:
 */

import { RouteRecordRaw } from 'vue-router'
import { isExternal } from './validate'

/**
 * 自定义重命名 - 路由类型
 */
export type RoutesDataItem = RouteRecordRaw & {
  key: string
  title: string
  parentPath?: string[]
  hidden?: boolean
  icon?: string
  children?: RoutesDataItem[]
  islastItem?: boolean
  noDivider?: boolean
}
/**
 * 用Routes的path作为key的JsonRoutes
 */
export interface PathJsonRoutesDataItem {
  [path: string]: RoutesDataItem
}
/**
 * 格式化返回 vue 路由, 主要处理特殊情况
 * @param routesData routes
 * @param parentPath 父path - 默认 /
 * @param headStart 路由起始头 - 默认 /
 */
export const vueRoutes = (
  routesData: RoutesDataItem[],
  parentPath = '/',
  headStart = '/',
): RoutesDataItem[] => {
  const n: RoutesDataItem[] = []
  let lastItem: RoutesDataItem | null = null
  routesData.forEach((item, i) => {
    const { children } = item
    const itemChildren = children || []
    const newItem: RoutesDataItem = { ...item }
    newItem.path = setRoutePathForParent(newItem.path, parentPath, headStart)

    if (item.children) {
      newItem.children = [...vueRoutes(itemChildren, newItem.path, headStart)]
      if (lastItem) {
        lastItem.islastItem = true
      }

      if (routesData[i + 1] && !routesData[i + 1].meta?.hideInMenu && !routesData[i + 1].children) {
        newItem.noDivider = true
      }
    }
    if (!newItem?.meta?.hideInMenu) {
      lastItem = newItem
    }
    n.push(newItem)
  })

  return n
}
/**
 * 根据父path 设置当前项 path
 * @param pathname path
 * @param parentPath 父path - 默认 /
 * @param headStart 路由起始头 - 默认 /
 */
export const setRoutePathForParent = (
  pathname: string,
  parentPath = '/',
  headStart = '/',
): string => {
  if (isExternal(pathname)) {
    return pathname
  }

  return pathname.substr(0, headStart.length) === headStart ? pathname : `${parentPath}/${pathname}`
}
/**
 * 把经过 vueRoutes 处理过的 routes 转换成用path作为key的json，并统一增加了parentPath
 * @param vueRoutesData 经过 vueRoutes 处理过的 routes
 * @returns PathJsonRoutesDataItem
 */
export const jsonPathVueRoutes = (vueRoutesData: RoutesDataItem[]): PathJsonRoutesDataItem => {
  const jsonRoutes: PathJsonRoutesDataItem = {}

  function forRoute(routesData: RoutesDataItem[], parentPath: string[]) {
    const len = routesData.length
    for (let index = 0; index < len; index++) {
      const item = routesData[index]

      const pPath = item.parentPath && item.parentPath.length > 0 ? item.parentPath : parentPath

      const newItem: RoutesDataItem = {
        ...item,
        parentPath: [...pPath],
      }

      jsonRoutes[item.path] = newItem

      if (item.children) {
        forRoute(item.children, [...pPath, item.path])
      }
    }
  }

  forRoute(vueRoutesData, [])

  return jsonRoutes
}
/**
 * 获取 route
 * @param pathname 当前路由path
 * @param jsonRoutesData 经过jsonPathVueRoutes处理，框架的所有路由
 * @returns
 */
export const getJsonRouteItem = (
  pathname: string,
  jsonRoutesData: PathJsonRoutesDataItem,
): RoutesDataItem => {
  return jsonRoutesData[pathname] || {}
}
/**
 * 根据 hidden 判断是否有数据子集
 * @param children RoutesDataItem[]
 */
export const hasChildRoute = (children: RoutesDataItem[]): boolean => {
  return children.filter((item) => {
    return item?.hidden ? false : true
  }).length > 0
    ? true
    : false
}

/**
 * 获取当前路由选中的侧边栏菜单path
 * @param route route
 */
export const getSelectLeftMenuPath = (route: any): string => {
  return route.path
}
